import { callApi } from '@local_modules/generic/fetch.js'

//
export async function loadEntityTrackings (accountingOrganisationId) {
  const apiUrl = '/api/xero-accounting/entity-data/:accountingOrganisationId/trackings'
  const data = await callApi(apiUrl, {
    accountingOrganisationId
  })
  console.log('api data', data)

  return data
}
